import { ITO } from "@amzn/ito-client";
import { SentryFetchHttpHandler } from "@amzn/sentry-fetch-http-handler";
import { API_BASE_URL } from "configuration/config";
import { AMZNHAM_CONSUMER, HAM_CONSUMER } from "interfaces/constants";

export type ITOConsumer = typeof HAM_CONSUMER | typeof AMZNHAM_CONSUMER;
const proxyMapping: { [key in ITOConsumer]: string } = {
    ham: "/ito",
    amznham: `/ito-${AMZNHAM_CONSUMER}`,
};

export function getITOClient(consumer?: ITOConsumer): { client: ITO; requestHandler: SentryFetchHttpHandler } {
    const requestHandler = new SentryFetchHttpHandler();

    // Use ITMP as default consumer
    consumer = consumer ?? HAM_CONSUMER;

    return {
        client: new ITO({
            endpoint: API_BASE_URL + proxyMapping[consumer],
            region: "*",
            credentials: { accessKeyId: "", secretAccessKey: "" },
            requestHandler: requestHandler,
        }),
        requestHandler: requestHandler,
    };
}
